import { createAction } from '@reduxjs/toolkit';

export const setHasNavigatedToHome = createAction(
  'NAVIGATION-SET_HAS_NAVIGATED_TO_HOME',
  (hasNavigated: boolean) => ({ payload: { hasNavigated } })
);
